import { Zap } from 'lucide-react'
import { cn } from '@/lib/cn'

/**
 * Marks a rush order everywhere a person might meet it. Nothing renders for a
 * standard order, so this can be dropped in unconditionally.
 *
 * - `portal` is the tinted Icewall chip for the staff, partner and admin consoles.
 * - `print` is a bordered black-on-white box: the job sheet is worked from
 *   paper, and a mono laser flattens a background tint into nothing.
 * - `storefront` is a neutral outline pill with the accent only on the text,
 *   because the tinted recipe is banned from the storefront surface.
 */
export default function UrgentBadge({
  urgent,
  variant = 'portal',
  className,
}: {
  urgent?: boolean | null
  variant?: 'portal' | 'print' | 'storefront'
  className?: string
}) {
  if (!urgent) return null

  if (variant === 'print') {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1 rounded border-2 border-black px-2 py-0.5 text-xs font-extrabold uppercase tracking-wide text-black',
          className,
        )}
      >
        Urgent
      </span>
    )
  }

  if (variant === 'storefront') {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1 rounded-full border border-foreground/15 px-2 py-0.5 text-2xs font-semibold uppercase tracking-wide text-danger',
          className,
        )}
      >
        <Zap className="size-3" />
        Urgent
      </span>
    )
  }

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border border-status-danger/60 bg-status-danger/20 px-2 py-0.5 text-2xs font-bold uppercase tracking-wide text-status-danger',
        className,
      )}
    >
      <Zap className="size-3" />
      Urgent
    </span>
  )
}
